import React, {Component} from 'react';
import {observer} from 'mobx-react';
import {action, observable} from 'mobx';

/**
 * Create a wrapper composition to support Tooltip functionality
 * @param ComposedComponent
 * @returns {{Component}}
 */

export function withTooltip(ComposedComponent) {
    return @observer class extends Component {
        static displayName = "withTooltip";

        @observable dismiss = false;
        @observable isOpen = false;
        @observable anchorEl = null;

        @action dismissTooltip = () => {
            this.dismiss = true;
            setTimeout(action(() => {
                this.dismiss = false;
                this.isOpen = false;
            }));
        };

        @action onOpenTooltip = (event) => {
            this.isOpen = true;
            this.setAnchorEl(event);
        };

        @action onDismissTooltip = () => {
            this.isOpen = false;
        };

        @action onToggleTooltip = (event) => {
            this.isOpen = !this.isOpen;
            this.setAnchorEl(event);
        };

        @action setAnchorEl = (event = {}) => {
            if (this.isOpen && event.currentTarget) {
                this.anchorEl = event.currentTarget;
            }
        }

        render() {
            return <ComposedComponent
                {...this.props}
                dismiss={this.dismiss}
                dismissTooltip={this.dismissTooltip}
                onOpenTooltip={this.onOpenTooltip}
                onDismissTooltip={this.onDismissTooltip}
                onToggleTooltip={this.onToggleTooltip}
                isTooltipOpen={this.isOpen}
                anchorEl={this.anchorEl}
            />;
        }
    };
}
